export default __webpack_public_path__ + "static/media/nft_1.61d4aefb.jfif";